import { Grid } from "@mui/material";

import {
  RRDAddressArea,
  RRDCouponGrid,
  RRDExpirationText,
  RRDFixedImageSlot,
  RRDImageSlot,
  RRDPageLabel,
} from "./RRDTemplateSlots";
import { couponSlots, fixedSlot, slotsByType } from "./rrdLayoutSlotHelpers";
import type { RRDLayoutProps } from "./layoutTypes";

function BasicPostcard4CFixedLayout(props: RRDLayoutProps) {
  const {
    layoutSpec,
    heroImages,
    coupons,
    fixedImages,
    frontExpirationDate,
    mode,
  } = props;
  const heroSlot = slotsByType(layoutSpec, "hero_image")[0];

  return (
    <>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Front</RRDPageLabel>
        <RRDImageSlot {...props} slot={heroSlot} placeholder="Hero Image" />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <RRDPageLabel>Back</RRDPageLabel>
        <Grid container spacing={0}>
          <Grid size={7}>
            <RRDCouponGrid
              slots={couponSlots(layoutSpec, "back")}
              layoutSpec={layoutSpec}
              heroImages={heroImages}
              coupons={coupons}
              mode={mode}
              onOpenMobileSlot={props.onOpenMobileSlot}
              onRemoveAsset={props.onRemoveAsset}
              readOnly={props.readOnly}
            />
          </Grid>
          <Grid size={5}>
            <RRDFixedImageSlot
              fixedImages={fixedImages}
              slot={fixedSlot(layoutSpec)}
            />
            <RRDAddressArea />
          </Grid>
        </Grid>
        <RRDExpirationText>{frontExpirationDate}</RRDExpirationText>
      </Grid>
    </>
  );
}

export default BasicPostcard4CFixedLayout;
